export const MESSAGES_LOADED = "messages/loaded"
export const MESSAGE_ADDED = "messages/messageAdded"
export const MESSAGES_DELETED = "messages/messagesDeleted"